import { sumBy } from "lodash";

import { isQueryableSpendFilter, SpendFilters } from "lib/hooks/api/spend/spendFilters";
import { useSpendOverTime } from "lib/hooks/api/spend/useSpendOverTime";
import { SpendGroupBy, SpendTimeUnit } from "lib/types/graphQLEnums";

/**
 * The headline for the results bar: how many transactions the filters match and what they
 * come to. It depends on the filters alone, so it holds still whichever view is on screen.
 *
 * One query answers both numbers: bucketed by year, since only the totals are wanted, and
 * each bucket already carries its transaction count as well as its value.
 */
export function useSpendHeadline(
  filters: SpendFilters,
  { enabled = true }: { enabled?: boolean } = {},
): { transactionCount?: number; totalValue?: number; isLoading: boolean } {
  const isEnabled = enabled && isQueryableSpendFilter(filters);
  const { data, isLoading } = useSpendOverTime(
    { filters, dateUnit: SpendTimeUnit.Year, groupBy: SpendGroupBy.None },
    { enabled: isEnabled },
  );

  if (!isEnabled || !data) {
    return {
      transactionCount: undefined,
      totalValue: undefined,
      isLoading: isEnabled && isLoading,
    };
  }
  return {
    transactionCount: sumBy(data.points, (p) => p.transactionCount),
    totalValue: sumBy(data.points, (p) => p.totalValue),
    isLoading: false,
  };
}
